export class StorageLimitReachedError extends Error {
}
export class DomainBasedIntranetAccessConfigurationError extends Error {
}
